<div class="update-company-page">

    <div class="page-header">
        <h2>Update Company Details</h2>
        <a class="close-btn" (click)="appservice.back()">✕</a>
    </div>

    <div class="form-card">
        <div class="layout-grid">
            
            <!-- Left side: Form -->
            <div>
                <form #addForm="ngForm" (ngSubmit)="updateCompany(addForm)">
                    
                    <div class="form-grid">
                        
                        <div class="form-group full-width">
                            <label>Company Name <span class="text-danger">*</span></label>
                            <input type="text" [(ngModel)]="uptC.CM_Name" name="CM_Name" #CM_Name="ngModel" required>
                        </div>

                        <div class="form-group full-width">
                            <label>Address 1</label>
                            <input type="text" [(ngModel)]="uptC.CM_Address1" name="CM_Address1" #CM_Address1="ngModel">
                        </div>

                        <div class="form-group full-width">
                            <label>Address 2</label>
                            <input type="text" [(ngModel)]="uptC.CM_Address2" name="CM_Address2" #CM_Address2="ngModel">
                        </div>

                        <div class="form-group full-width">
                            <label>Address 3</label>
                            <input type="text" [(ngModel)]="uptC.CM_Address3" name="CM_Address3" #CM_Address3="ngModel">
                        </div>

                        <div class="form-group">
                            <label>State</label>
                            <select [(ngModel)]="uptC.CM_State" name="CM_State" #CM_State="ngModel">
                                <option value="Tamil Nadu">Tamil Nadu</option>
                                <option value="Karnataka">Karnataka</option>
                                <option value="Kerala">Kerala</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label>Pin Code</label>
                            <input type="text" [(ngModel)]="uptC.CM_Address5" name="CM_Address5" #CM_Address5="ngModel">
                        </div>

                        <div class="form-group">
                            <label>GST No</label>
                            <input type="text" [(ngModel)]="uptC.CM_GST_No" name="CM_GST_No" #CM_GST_No="ngModel">
                        </div>

                        <div class="form-group">
                            <label>Email</label>
                            <input type="text" [(ngModel)]="uptC.CM_Email_ID" name="CM_Email_ID" #CM_Email_ID="ngModel">
                        </div>

                        <div class="form-group">
                            <label>Phone Number</label>
                            <input type="text" [(ngModel)]="uptC.CM_Phone_off" name="CM_Phone_off" #CM_Phone_off="ngModel">
                        </div>

                        <div class="form-group">
                            <label>Mobile No</label>
                            <input type="text" [(ngModel)]="uptC.CM_Phone_Res" name="CM_Phone_Res" #CM_Phone_Res="ngModel">
                        </div>

                        <div class="form-group">
                            <label>Bank Name</label>
                            <input type="text" [(ngModel)]="uptC.CM_Bank_Name" name="CM_Bank_Name" #CM_Bank_Name="ngModel">
                        </div>

                        <div class="form-group">
                            <label>Acc Name</label>
                            <input type="text" [(ngModel)]="uptC.CM_Acc_Name" name="CM_Acc_Name" #CM_Acc_Name="ngModel">
                        </div>

                        <div class="form-group">
                            <label>Account No</label>
                            <input type="text" [(ngModel)]="uptC.CM_Acc_Number" name="CM_Acc_Number" #CM_Acc_Number="ngModel">
                        </div>

                        <div class="form-group">
                            <label>IFSC Code</label>
                            <input type="text" [(ngModel)]="uptC.CM_IFSC" name="CM_IFSC" #CM_IFSC="ngModel">
                        </div>

                        <div class="form-group full-width">
                            <label>Branch</label>
                            <input type="text" [(ngModel)]="uptC.CM_Branch" name="CM_Branch" #CM_Branch="ngModel">
                        </div>

                        <div class="form-group full-width">
                            <label>Sales Footer</label>
                            <input type="text" [(ngModel)]="uptC.CM_Sales_Footer" name="CM_Sales_Footer" #CM_Sales_Footer="ngModel">
                        </div>

                        <div class="form-group full-width">
                            <label>Sales Term</label>
                            <textarea rows="4" [(ngModel)]="uptC.CM_Sales_Term" name="CM_Sales_Term" #CM_Sales_Term="ngModel"></textarea>
                        </div>

                    </div>

                    <div *ngIf="uptCompany" class="alert alert-info mt-3 text-center" style="background: rgba(23, 162, 184, 0.2); color: #17a2b8; border: 1px solid #17a2b8; border-radius: 8px; padding: 10px;">
                        <strong>Saved Successfully</strong>
                    </div>

                    <div class="text-center">
                        <button class="save-btn" [disabled]="btndisable" type="submit">
                            <span *ngIf="btndisable" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <i *ngIf="!btndisable" class='bx bx-paper-plane'></i>
                            Save &amp; Update
                        </button>
                    </div>

                </form>
            </div>

            <!-- Right side: Image uploads -->
            <div class="upload-section">
                
                <div class="upload-box">
                    <img [src]="get_Company_image()" *ngIf="get_Company_image()" />
                    <div class="form-group">
                        <label>Upload Company Logo</label>
                        <p-fileUpload name="myfile[]" url="{{server}}" (onUpload)="onUpload($event)" multiple="multiple" maxFileSize="1000000">
                            <ng-template pTemplate="content">
                                <ul *ngIf="uploadedFiles.length">
                                    <li *ngFor="let file of uploadedFiles">{{file.name}} - {{file.size}} bytes</li>
                                </ul>
                            </ng-template>
                        </p-fileUpload>
                    </div>
                </div>

                <div class="upload-box">
                    <img [src]="get_Company_sign()" *ngIf="get_Company_sign()" />
                    <div class="form-group">
                        <label>Upload Company Signature</label>
                        <p-fileUpload name="myfile[]" url="{{server_sign}}" (onUpload)="onUpload($event)" multiple="multiple" maxFileSize="1000000">
                            <ng-template pTemplate="content">
                                <ul *ngIf="uploadedFiles.length">
                                    <li *ngFor="let file of uploadedFiles">{{file.name}} - {{file.size}} bytes</li>
                                </ul>
                            </ng-template>
                        </p-fileUpload>
                    </div>
                </div>

            </div>

        </div>
    </div>

</div>